import getEnvVar from '@/utils/getEnvVar';
import { AdobeAnalyticsConst } from '../adobeAnalyticsConstants/adobeAnalyticsConstants';
import { LocationInfo } from '../types/AdobeAnalyticsTypes';

export const getCommonPagePayload = (locationInfo: LocationInfo, pageIdentifier: string) => {
  const isBrowser = typeof document !== 'undefined';

  return {
    siteName: AdobeAnalyticsConst.SITE_DETAILS.name,
    sysEnv: getEnvVar('MODE') ?? 'unknown',
    url: locationInfo?.url ?? '',
    domain: locationInfo?.hostname ?? '',
    path: locationInfo?.pathname ?? '',
    pageTitle: isBrowser ? document.title : '',
    pageName: pageIdentifier ?? '',
    referrer: isBrowser ? document.referrer : '',
  };
};
